import React from "react"
import { Col, Form, Row, Select } from "antd"
import { UseData } from "../../../hooks/useReactQuery"
import FileUpload from "../../FileUpload"
import RefetchButton from "../../RefetchButton"

export default function AddVariation({ selectedOption, setSelectedOption, success, imageName, setFileHandle, form }) {
  const { data, isLoading, isError, refetch, isRefetching } = UseData("options", "product-option/all")

  if (isError) return "Error"

  const handleOnChange = (name, value) => {
    const parsedObj = value ? JSON.parse(value) : ""
    setSelectedOption((prev) => ({ ...prev, [name]: parsedObj }))

    if (name === "name") {
      form.setFieldsValue({
        value: "",
      })
      return
    }
  }

  return (
    <>
      <Row gutter={20}>
        <Col span={12}>
          <div className="relative pr-10">
            <Form.Item
              name="name"
              label="Variation name"
              rules={[
                {
                  required: true,
                  message: "Please select variation name",
                },
              ]}
            >
              <Select
                placeholder="Select a name"
                allowClear
                showSearch
                filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                loading={isLoading}
                onChange={(v) => handleOnChange("name", v)}
              >
                {data?.map((d) => (
                  <Select.Option value={JSON.stringify(d)} key={d.name} className="capitalize">
                    {d.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <RefetchButton name="Variations" loading={isRefetching || isLoading} refetch={refetch} />
          </div>
        </Col>
        {selectedOption?.name && (
          <Col span={12}>
            <div className="relative pr-10">
              <Form.Item
                name="value"
                label="Variation Value"
                rules={[
                  {
                    required: true,
                    message: "Please select variation value",
                  },
                ]}
              >
                <Select
                  placeholder="Select a value"
                  allowClear
                  showSearch
                  filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                  loading={isLoading}
                  onChange={(v) => handleOnChange("value", v)}
                >
                  {selectedOption?.name?.variations?.map((d) => (
                    <Select.Option value={JSON.stringify(d)} key={d.name} className="capitalize">
                      {d.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
              <RefetchButton name="Variations name" loading={isRefetching || isLoading} refetch={refetch} />
            </div>
          </Col>
        )}
        <Col span={24}>
          <FileUpload setFileHandle={setFileHandle} image={imageName} success={success} />
        </Col>
      </Row>
    </>
  )
}
